import { IPaymentMethod } from 'state/payment/types';
import { isApplePay, isGooglePay } from 'utils/payment/native-payment';

import { IGetSortedValidPaymentMethods, ISortedValidPaymentMethods } from '../types';

const isAppleOrGooglePay = (accountIdentifier: string | null) =>
  isApplePay(accountIdentifier) || isGooglePay(accountIdentifier);
const isVaultedCC = (paymentMethod: IPaymentMethod) =>
  paymentMethod.credit && !!paymentMethod.chaseProfileId;
const isPrepaidPaymentMethod = (paymentMethod: IPaymentMethod) => !!paymentMethod.prepaid;

export const isValidScanAndPayPaymentMethod = (paymentMethod: IPaymentMethod) => {
  return (
    !isAppleOrGooglePay(paymentMethod.accountIdentifier) &&
    (isVaultedCC(paymentMethod) || isPrepaidPaymentMethod(paymentMethod))
  );
};

export const hasValidScanAndPayPaymentMethodOption = (paymentMethods: IPaymentMethod[]) =>
  paymentMethods.some(isValidScanAndPayPaymentMethod);

export const getSortedValidPaymentMethods = ({
  paymentMethods,
  selectedPaymentMethodId,
}: IGetSortedValidPaymentMethods) =>
  paymentMethods.reduce(
    (acc, option) => {
      if (selectedPaymentMethodId && option.accountIdentifier === selectedPaymentMethodId) {
        acc.selectedPaymentMethod = option;
      } else if (isValidScanAndPayPaymentMethod(option)) {
        acc.nonSelectedPaymentMethods.push(option);
      }
      return acc;
    },
    {
      selectedPaymentMethod: undefined,
      nonSelectedPaymentMethods: [] as IPaymentMethod[],
    } as ISortedValidPaymentMethods
  );

export const getDefaultPaymentMethodId = (paymentMethods: IPaymentMethod[]) => {
  const ccPaymentMethod = paymentMethods.find(
    paymentMethod =>
      isValidScanAndPayPaymentMethod(paymentMethod) && !isPrepaidPaymentMethod(paymentMethod)
  );
  const prepaidPaymentMethod = paymentMethods.find(
    paymentMethod =>
      isValidScanAndPayPaymentMethod(paymentMethod) && isPrepaidPaymentMethod(paymentMethod)
  );
  if (ccPaymentMethod?.accountIdentifier) {
    return ccPaymentMethod.accountIdentifier;
  }
  if (prepaidPaymentMethod?.accountIdentifier) {
    return prepaidPaymentMethod.accountIdentifier;
  }
  return '';
};
